import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const hasDiscountConfigured = {
  name: "hasDiscountConfigured" as const,
  input: z.object({ conversationId: zExt.objectId() }),
  output: z.object({ hasDiscount: z.boolean() }),
};
